import { patch } from './api';
import { saveBranchPreference } from './branchPreference';
export default async function selectBranch(branch, user) {
  if (user?.role === 'CUSTOMER') await patch('/branches/current', { branchId: branch.id });
  saveBranchPreference(branch.id);
  window.dispatchEvent(new Event('branch-changed'));
  window.dispatchEvent(new Event('catalog-preference-changed'));
}
